import React from 'react';
import PropTypes from 'prop-types';
import { classnames } from 'Utils/classnames';
import Icon from '../../Icon';
import { CELL_TYPES } from '../constants';

const Cell = ({ rowNo, colNo, isLegNumber, isAllSelectButton, legCount, data, selectedData, onCellClick, legNo, runwayType, isAllSelected }) => {

  const isSelected = selectedData[legNo]?.some(item => item?.horseNo === data?.horseNo);

  const className = classnames({
    'newBetSlip__runs-box': true,
    'cell--standard': data && data?.isRunning,
    'cell--disabled': data && !data?.isRunning,
    'cell--number': isLegNumber && (runwayType !== 'SAND' || runwayType !== 'TAPETA' || runwayType !== 'SYNTHETIC'),
    'cell--sand': isLegNumber && runwayType === 'SAND',
    'cell--tapeta': isLegNumber && (runwayType === 'TAPETA' || runwayType === 'SYNTHETIC'),
    'cell--selected': isSelected,
    'cell--agt': data?.agfOrderNo === 1,
    'cell--button': isAllSelectButton,
    'cell--button allSelected': isAllSelectButton && isAllSelected && !(colNo + 1 > legCount),
    'cell--empty': colNo + 1 > legCount
  });

  const getValue = () => {
    if (isLegNumber) {
      return colNo + 1;
    }

    if (isAllSelectButton) {
      return 'H';
    }

    if (!data) {
      return '';
    }

    if (data.isRunning) {
      return data.horseNo;
    }

    return <Icon iconName="svgDisallow"/>;
  };
  
  const value = getValue();

  const onClick = () => {
    if (data?.isRunning) {
      onCellClick(legNo, { colNo, ...data }, CELL_TYPES.HORSE);
    } else  if (isAllSelectButton  && !(colNo + 1 > legCount)) {
      onCellClick(legNo, { isAllSelected, colNo  }, CELL_TYPES.ALL_SELECT_BUTTON);
    } else  if (isLegNumber && !(colNo + 1 > legCount)) {
      onCellClick(legNo, {  colNo  }, CELL_TYPES.LEG_NO);
    }
  };

  return (
    <div onClick={ onClick } className={ className }>{ colNo  + 1 <= legCount && value }</div>
  );
};

Cell.propTypes = {
  rowNo: PropTypes.number.isRequired,
  colNo: PropTypes.number.isRequired,
  legNo: PropTypes.number,
  isLegNumber: PropTypes.bool.isRequired,
  isAllSelectButton: PropTypes.bool.isRequired,
  isAllSelected: PropTypes.bool.isRequired,
  selectedData: PropTypes.object,
  legCount: PropTypes.number.isRequired,
  data: PropTypes.object,
  onCellClick: PropTypes.func,
  runwayType: PropTypes.string
};

export default Cell;
